import { Typography } from "@material-ui/core";
import DevicesOtherOutlinedIcon from "@material-ui/icons/DevicesOtherOutlined";
import React from "react";
import { Link } from "react-router-dom";

import { useCardWidgetStyles } from "./cardWidgetStyles";

interface Props {
    url: string;
}

export function OpenSiteConfigurationWidget({ url }: Props) {
    const classes = useCardWidgetStyles();

    return (
        <Link className={classes.container} to={url} title="Open Site Configuration">
            <div className={classes.summary}>
                <DevicesOtherOutlinedIcon className={classes.icon} />
                <Typography className={classes.descr}>Open Site Configuration</Typography>
            </div>
        </Link>
    );
}
